export default function AdminHome() {
  return (
    <>
      <h1>Admin Home</h1>
    </>
  )
}
